import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import applyOnboardingRestriction from '../../hooks/applyOnboardingRestriction';
import { resetFormBuilderStateAction } from '../../reducers/formBuilder';
import { RX_FORM_TYPES } from '../../components/RxForm/constants';
import { isRetainerCaseCreationEnabled } from '../../selectors/globalSettings';
import CaseTypeSelection from './CaseTypeSelection';
import AddIdbRxForm from './IDB/AddIdbRxForm';
import AddRetainerRxForm from './Retainer/AddRetainerRxForm';

const TYPES = [RX_FORM_TYPES.IDB, RX_FORM_TYPES.RETAINER];

const AddRxForm = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const retainerCasesEnabled = useSelector(isRetainerCaseCreationEnabled);
  const params = new URLSearchParams(location.search);
  const type = params.get('type');
  const requestedType = TYPES.includes(type) ? type : null;
  const effectiveType = retainerCasesEnabled ? requestedType : RX_FORM_TYPES.IDB;

  useEffect(() => {
    dispatch(resetFormBuilderStateAction());
  }, [effectiveType, dispatch]);

  if (effectiveType === RX_FORM_TYPES.IDB) {
    return <AddIdbRxForm match={match} />;
  }

  if (!requestedType) {
    return (
      <CaseTypeSelection
        onSelect={nextType => {
          history.push(`${location.pathname}?type=${nextType}`);
        }}
      />
    );
  }

  return <AddRetainerRxForm match={match} />;
};

AddRxForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object
};

AddRxForm.defaultProps = {
  match: { params: {} }
};

export default applyOnboardingRestriction(AddRxForm);
